import { render, staticRenderFns } from "./historical-trend.editor.vue?vue&type=template&id=be54d3fa&scoped=true&"
import script from "./historical-trend.editor.vue?vue&type=script&lang=ts&"
export * from "./historical-trend.editor.vue?vue&type=script&lang=ts&"
import style0 from "./historical-trend.editor.vue?vue&type=style&index=0&id=be54d3fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be54d3fa",
  null
  
)

export default component.exports